<template>
  <div
    class="
      custom-group-tours-difference
      pt-80
      mb-pt-60
      pb-100
      mb-pb-60
      bd-y-2 bd-dash bd-green-dark
      mb-100 mb-mb-40
    "
  >
    <div class="container">
      <div class="text flex fw-700 flex-column items-center justify-center pb-40">
        <h2 class="fs-40 fw-700 mb-fs-32 lh-52 mb-8 ls-1 tc">
          {{ DIFFERENCE_HEADER }}
        </h2>
        <p class="fs-16 lh-20 gray-dark ls-1">{{ DIFFERENCE_SUBHEADER }}</p>
      </div>
      <div class="flex justify-center grid-gap-28 tl-grid-gap-16 flex-wrap">
        <CGTDifferenceCard
          v-for="(item, key) in differenceContent"
          :key="key"
          :data="item"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  DIFFERENCE_HEADER,
  DIFFERENCE_SUBHEADER,
  DIFFERENCE_CONTENT,
} from '~/constant/customGroupTours'
import {
  SCHOOL_DIFFERENCE_CONTENT,
} from '~/constant/schoolTourDetails'
import CGTDifferenceCard from '~/components/pages/LandingPage/CGTDifference/CGTDifferenceCard.vue'
import { useRoute } from 'vue-router'
import { SCHOOL_TOUR_ROUTE } from '~/constant/common.js'

const route = useRoute()

const differenceContent = computed(() => {
  if(route.name === SCHOOL_TOUR_ROUTE.name) return SCHOOL_DIFFERENCE_CONTENT
  return DIFFERENCE_CONTENT
})

</script>

<style lang="scss" scoped></style>
